import React from 'react';

import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface Props {
  open: boolean;
  title: string;
  description: string;
  confirmLabel: string;
  warning?: string;
  isSubmitting: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export default function ConfirmActionDialog({
  open,
  title,
  description,
  confirmLabel,
  warning,
  isSubmitting,
  onConfirm,
  onClose,
}: Props) {
  return (
    <Dialog open={open} onClose={isSubmitting ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>

      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
        {!!warning && (
          <Alert severity="warning" sx={{ mt: 2 }}>
            {warning}
          </Alert>
        )}
      </DialogContent>

      <DialogActions>
        <Button variant="contained" color="primary" onClick={onConfirm} disabled={isSubmitting}>
          {confirmLabel}
        </Button>
        <Button variant="text" onClick={onClose} disabled={isSubmitting}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
